import { Controller } from "@hotwired/stimulus"

// 6-cell OTP input with auto-advance and paste handling.
// Posts the concatenated value via a hidden field.
export default class extends Controller {
  static targets = ["cell", "value", "submit"]

  connect() {
    this.cellTargets.forEach((cell, i) => {
      cell.addEventListener("input", (e) => this.handleInput(e, i))
      cell.addEventListener("keydown", (e) => this.handleKeydown(e, i))
      cell.addEventListener("paste", (e) => this.handlePaste(e))
    })
    this.cellTargets[0]?.focus()
    this.sync()
  }

  handleInput(e, i) {
    const v = e.target.value.replace(/\D/g, "").slice(0, 1)
    e.target.value = v
    if (v) {
      e.target.classList.add("filled")
      this.cellTargets[i + 1]?.focus()
    } else {
      e.target.classList.remove("filled")
    }
    this.sync()
  }

  handleKeydown(e, i) {
    if (e.key === "Backspace" && !e.target.value && i > 0) {
      const prev = this.cellTargets[i - 1]
      prev.focus()
      prev.value = ""
      prev.classList.remove("filled")
      this.sync()
    }
  }

  handlePaste(e) {
    e.preventDefault()
    const text = (e.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "").slice(0, 6)
    ;[...text].forEach((ch, i) => {
      if (this.cellTargets[i]) {
        this.cellTargets[i].value = ch
        this.cellTargets[i].classList.add("filled")
      }
    })
    if (text.length < 6) {
      this.cellTargets[text.length]?.focus()
    } else {
      this.cellTargets[5]?.blur()
    }
    this.sync()
  }

  sync() {
    const code = this.cellTargets.map((c) => c.value).join("")
    if (this.hasValueTarget) this.valueTarget.value = code
    if (this.hasSubmitTarget) this.submitTarget.disabled = code.length !== 6
  }
}
